import React from "react"
import { useCallback } from "react"
import { useToast } from "@/hooks/useToast"

// Define the type for the showToastMessage function
export type ShowToastMessageFn = (message: string, title?: string) => void;

// Define a type for the props that WithToast will inject
export interface WithToastProps {
    showToastMessage: ShowToastMessageFn;
}

// Higher-order component that adds toast functionality to a wrapped component
const WithToast = <P extends object>(
    WrappedComponent: React.ComponentType<P & WithToastProps>) => {

    const WithToastComponent = (props: Omit<P, keyof WithToastProps>) => {
        const { toast } = useToast()

        const showToastMessage = useCallback(
            (message: string, title?: string) => {
                toast({
                    title: title || "Notification",
                    description: message,
                    duration: 3000,
                })
            },
            [toast],
        )

        return <WrappedComponent {...(props as P)} showToastMessage={showToastMessage} />;
    }
    return WithToastComponent
}

export default WithToast
